/**
 * Managed toolbar IDs — toolbars that support the full button API
 * (`addToolbarButton`, `updateToolbarButtonState`, `reorderToolbar`, etc.).
 */
export const CORE_TOOLBAR_IDS = {
    DETAILS: "details",
    BOTTOM_NAV: "bottom-nav",
    ADVANCED_FEATURES: "advanced-features-menu",
} as const;

export type CoreToolbarId = (typeof CORE_TOOLBAR_IDS)[keyof typeof CORE_TOOLBAR_IDS];

/**
 * All toolbar IDs that can be shown or hidden via `configureToolbarVisibility` / `setToolbarVisible`.
 *
 * This is a superset of {@link CORE_TOOLBAR_IDS}:
 * - `DETAILS` is a managed toolbar and also supports visibility control.
 * - `QUICK_ACCESS` and `NAV_WHEEL` are visibility-only — they are not managed
 *   toolbars and do not support button APIs.
 */
export const VISIBILITY_TOOLBAR_IDS = {
    DETAILS: "details",
    QUICK_ACCESS: "quick-access",
    NAV_WHEEL: "nav-wheel",
    ADVANCED_FEATURES: "advanced-features-menu",
} as const;

export type VisibilityToolbarId = (typeof VISIBILITY_TOOLBAR_IDS)[keyof typeof VISIBILITY_TOOLBAR_IDS];
